var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMutiaraBali)?_c('div',{staticClass:"mb-2"},[_c('div',{staticClass:"is-size-5 has-text-centered"},[_vm._v(_vm._s(_vm.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }